import { Box, styled } from "@mui/material";

export const StyledTabContentContainer = styled(Box)(({ theme }) => ({
  gap: theme.spacing(0.5),
  display: "flex",
  flexDirection: "column",
})) as typeof Box;
